var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "topbar"
  }, [_c('EmpresaSelector'), _vm.souRevenda ? _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-top": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "text",
      "id": "search-client",
      "placeholder": "Trocar de conta",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.searchQuery = $event.target.value;
      }
    }
  }), _vm.searchQuery && _vm.filteredClients.length > 0 ? _c('div', {
    staticClass: "client-list"
  }, [_c('ul', _vm._l(_vm.filteredClients, function (client) {
    return _c('li', {
      key: client.id,
      staticClass: "client-item",
      on: {
        "click": function click($event) {
          return _vm.selectClient(client);
        }
      }
    }, [_c('strong', {
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(client.cliente) + " - " + _vm._s(_vm.formatCpfCnpj(client.cnpj_cpf)))]), _c('AccountCircle', {
      staticStyle: {
        "margin-left": "50px",
        "margin-right": "2px"
      },
      attrs: {
        "size": 20
      }
    }), _c('span', {
      staticStyle: {
        "margin-left": "2px"
      }
    }, [_vm._v(" ")])], 1);
  }), 0)]) : _vm._e()]) : _vm._e(), _c('b-dropdown', {
    attrs: {
      "size": "sm",
      "variant": "link",
      "toggle-class": "topbar-item text-decoration-none",
      "no-caret": "",
      "right": "",
      "no-flip": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg mr-1 pulse pulse-primary position-relative"
        }, [_c('span', {
          staticClass: "svg-icon svg-icon-xl"
        }, [_c('inline-svg', {
          attrs: {
            "src": "media/svg/icons/Code/Compiling.svg"
          }
        })], 1), _vm.notificationStore.total > 0 ? _c('span', {
          staticClass: "pulse-ring"
        }) : _vm._e(), _vm.notificationStore.total > 0 ? _c('span', {
          staticClass: "font-size-sm position-absolute notifications"
        }, [_vm._v(_vm._s(_vm.notificationStore.total))]) : _vm._e()])];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-text', {
    staticClass: "min-w-md-350px",
    attrs: {
      "tag": "div"
    }
  }, [_c('form', [_c('KTDropdownNotification')], 1)])], 1), _c('KTQuickUser')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };